import { useRequest } from '@features/request/useRequest';
import { useResetStoreData } from '@features/request/useResetStoreData';

import { useEffect, useMemo } from 'react';

import { catalogRatiosSubGroupsGql } from '../addRatiosModalQueries';

const requestId = 'catalogRatiosSubgroups';

export const useCatalogRatiosSubgroupsData = ({
    ratioGroupId,
    effect = true,
}: {
    ratioGroupId: number;
    effect?: boolean;
}) => {
    const variables = useMemo(() => ({ parentId: ratioGroupId }), [ratioGroupId]);

    const [groupsDataReset] = useResetStoreData({
        requestId,
    });

    useEffect(
        () => () => {
            groupsDataReset(undefined);
        },
        [groupsDataReset],
    );

    const [subgroupsData, subgroupsStatus] = useRequest({
        requestId,
        query: catalogRatiosSubGroupsGql,
        variables,
        withEffect: effect && !!ratioGroupId,
    });

    return useMemo(
        () => ({
            subgroupsData: subgroupsData?.catalogRatioSubGroups ?? [],
            subgroupsStatus,
            groupsDataReset,
        }),
        [subgroupsData?.catalogRatioSubGroups, subgroupsStatus, groupsDataReset],
    );
};
